import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    navigator.clipboard.writeText(this.textValue).then(() => {
      window.toast('Copied to clipboard', { type: 'success' })

      const button = event.currentTarget
      const originalClass = button.className
      button.classList.add('text-green-600')
      setTimeout(() => { button.className = originalClass }, 2000)
    })
  }
}
